import { useQuery } from '@tanstack/react-query'

import axios from 'axios'

import { EMPTY_OBJECT } from 'Utils/stableDefaults'

export const DCC_PLUGINS_QUERY_KEY = ['dccPlugins']
export const DCC_PLUGINS_ENDPOINT = 'https://www.cgtrader.com/api/generator/dcc-plugins'
const ONE_DAY_IN_MS = 24 * 60 * 60 * 1000

// Public, unauthenticated endpoint: returns a flat { <software>: <version> }
// object (NOT a JSON:API envelope), e.g. { blender: '0.6.0', max: '0.6.0' }.
export async function fetchDccPlugins() {
  const { data } = await axios.get(DCC_PLUGINS_ENDPOINT)
  return data ?? EMPTY_OBJECT
}

function useDccPlugins({ enabled = true } = EMPTY_OBJECT) {
  const { data, isLoading, isError } = useQuery({
    queryKey: DCC_PLUGINS_QUERY_KEY,
    queryFn: fetchDccPlugins,
    staleTime: ONE_DAY_IN_MS,
    enabled,
  })

  return {
    plugins: data ?? EMPTY_OBJECT,
    isLoading,
    isError,
  }
}

export default useDccPlugins
